import Camp from 'elem/compPage/Camp';
import { useGlobal } from '@/utils/useGlobal';
import PageLayout from '@/components/PageLayout';
import seoconfig from '@/seoconfig/camp';
import SEOlinksA from '@/components/SEOlinksA';

export default function VanlifeRoadtripsPage({ SEO }: any) {
    const { useRouter, useEffect, useLang } = useGlobal();
    const { t } = useLang('camp');
    const router = useRouter();
    const { locale } = router;

    useEffect(() => {
        if (!['jp'].includes(locale)) {
            router.push('/404');
        }
    }, []);

    return (
        <PageLayout isNoFixed hideToTop>
            <SEO title={t('seo_title')} description={t('seo_desc')} />
            <SEOlinksA locale={String(locale)} list={seoconfig.include} pathname={seoconfig.url} />
            <Camp />
        </PageLayout>
    );
}
